import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import LandingPage from './views/LandingPage.vue';
import VendorLandingPage from './views/VendorLandingPage.vue';

import SearchResults from './views/SearchResults.vue';
import ContactUs from './views/miscellaneous/ContactUs.vue';
import TermsAndConditions from './views/miscellaneous/policies/TermsAndConditions.vue';
import ContentPolicy from './views/miscellaneous/policies/ContentPolicy.vue';
import PrivacyPolicy from './views/miscellaneous/policies/PrivacyPolicy.vue';
import SignIn from './views/user/auth/SignIn.vue';
import SignUp from './views/user/auth/SignUp.vue';
import AccountSettings from './views/user/AccountSettings.vue';
import ResetPasswordConfirm from './views/user/auth/misc/ResetPasswordConfirm.vue';
import VerifyEmail from './views/user/auth/misc/VerifyEmail.vue';

import Profile from './views/user/profile/Profile.vue';
import EditProfile from './views/user/profile/EditProfile.vue';

import ShopCreate from './views/shops/ShopCreate.vue';
import ShopEdit from './views/shops/ShopEdit.vue';
import MyShops from './views/shops/MyShops.vue';
import Shop from './views/shops/Shop.vue';

import ShopFinder from './views/shops/ShopFinder.vue';
import GrowingLocationFinder from './views/locations/growing/GrowingLocationFinder.vue';

import MyProducts from './views/products/MyProducts.vue';
import EditProduct from './views/products/EditProduct.vue';

import CreateShippingLocation from './views/locations/shipping/CreateShippingLocation.vue';
import EditShippingLocation from './views/locations/shipping/EditShippingLocation.vue';

import BlogLandingPage from './views/blogs/BlogLandingPage.vue';
import ListOfAllBlogPosts from './views/blogs/ListOfAllBlogPosts.vue';
import SpecificBlogPost from './views/blogs/SpecificBlogPost.vue';
import PostsByAuthor from './views/blogs/PostsByAuthor.vue';

import TaxonomicOrder from './views/guide/orders/TaxonomicOrder.vue';
import TaxonomicFamily from './views/guide/families/TaxonomicFamily.vue';
import Genus from './views/guide/genera/Genus.vue';
import Species from './views/guide/species/Species.vue';
import VarietyGroup from './views/guide/variety_groups/VarietyGroup.vue';
import SpecificVariety from './views/guide/varieties/SpecificVariety.vue';

import MyTrials from './views/tools/Measurements/MyTrials.vue';
import TrialDetails from './views/tools/Measurements/TrialDetails.vue';
import NewVarietyComponentMeasurement
  from './views/tools/Measurements/NewVarietyComponentMeasurement.vue';
import store from '@/store/store';


import Epi2x2 from './views/miscellaneous/hidden/Epi2x2.vue';
import ShopProductEdit from './views/shops/ShopProductEdit.vue';

import NotFound404 from './views/miscellaneous/errors/NotFound404.vue';

Vue.use(Router);


const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.token) {
    next();
    return;
  }
  next('/');
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters.token) {
    next();
    return;
  }
  next('/sign_in');
};

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/sign_in',
      name: 'sign_in',
      component: SignIn,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/sign_up',
      name: 'sign_up',
      component: SignUp,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/signup/verify-email/:key',
      component: VerifyEmail,

    },

    {
      path: '/user/confirm-password-reset/:uid/:key',
      component: ResetPasswordConfirm,

    },
    {
      path: '/user/account/settings/',
      component: AccountSettings,

    },
    {
      path: '/landing',
      name: 'landing',
      component: LandingPage,
    },
    {
      path: '/vendor',
      name: 'vendorlanding',
      component: VendorLandingPage,
    },
    {
      path: '/shops/:slug',
      name: 'shop',
      component: Shop,
    },
    {
      path: '/shop-finder/',
      name: 'shop-finder',
      component: ShopFinder,
    },
    {
      path: '/user/shops/',
      name: 'my_shop',
      component: MyShops,
    },
    {
      path: '/profiles/:slug/',
      component: Profile,
    },
    {
      path: '/forms/profiles/edit/',
      component: EditProfile,
    },
    {
      path: '/user/my-products/',
      component: MyProducts,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/forms/shop/create',
      name: 'create_shop',
      component: ShopCreate,
    },
    {
      path: '/forms/shop/edit/:shopslug',
      name: 'edit_shop',
      component: ShopEdit,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/forms/shop/products/:shopslug',
      name: 'edit_shop_products',
      component: ShopProductEdit,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/forms/products/edit/:slug',
      component: EditProduct,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/forms/locations/shipping/create',
      component: CreateShippingLocation,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/forms/locations/shipping/edit',
      component: EditShippingLocation,
      beforeEnter: ifAuthenticated,
    },
    // Misc. Routes
    {
      path: '/search_results/:search_query',
      component: SearchResults,

    },
    {
      path: '/forms/measurement/',
      component: NewVarietyComponentMeasurement,
    },
    {
      path: '/user/measurements/trials/',
      component: MyTrials,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/user/measurements/trials/:slug',
      component: TrialDetails,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/garden_finder/',
      name: 'growing-location-finder',
      component: GrowingLocationFinder,
    },
    //Guide Paths
    {
      path: '/guide/taxonomic_order/:slug',
      component: TaxonomicOrder,
    },
    {
      path: '/guide/taxonomic_family/:slug',
      component: TaxonomicFamily,
    },
    {
      path: '/guide/genus/:slug',
      component: Genus,
    },
    {
      path: '/guide/species/:slug',
      component: Species,
    },
    {
      path: '/guide/variety_group/:slug',
      component: VarietyGroup,
    },
    {
      path: '/guide/variety/:slug',
      component: SpecificVariety,
    },
    // Blog Paths
    {
      path: '/blog/',
      component: BlogLandingPage,
    },
    {
      path: '/blog/posts/:slug',
      component: SpecificBlogPost,
    },
    {
      path: '/blog/list/all/',
      component: ListOfAllBlogPosts,
    },
    // Misc Paths
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '/contact',
      name: 'contact',
      component: ContactUs,
    },
    // // Policy Routes
    {
      path: '/policies/content',
      name: 'content',
      component: ContentPolicy,
    },
    {
      path: '/policies/privacy',
      name: 'privacy',
      component: PrivacyPolicy,
    },
    {
      path: '/policies/terms',
      name: 'terms',
      component: TermsAndConditions,
    },
    {
      path: '/epi/2x2/',
      name: 'epi2x2',
      component: Epi2x2,
    },
    // errors and such
    {
      path: '*',
      name: 'NotFound404',
      component: NotFound404,
    },

  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
